import styled, { css } from "styled-components"
import device from "../../theme/devices"
import constants from "../../theme/constants"
import { IconButtonWithShadow } from "../styles/Buttons.styled"
import GridLayout from "../../layouts/GridLayout"

export const ScrollableContainer = styled.div`
  overflow-x: ${props => (props.disableScroll ? "hidden" : "auto")};
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  display: grid;
  grid-template-columns:
    ${props => (props.fullWidth ? 0 : "1fr")} minmax(0, 1440px)
    1fr;
  position: relative;
`

export const HostContainer = styled(GridLayout)`
  grid-column: 2;
  min-width: 100%;
  ${props =>
    props.fullWidth &&
    css`
      padding-left: 0 !important;
    `}
`

export const ItemHost = styled.div`
  min-width: 100%;
  display: flex;
  flex-direction: row;
  max-width: 100%;
  overflow-x: visible;
  scroll-behavior: smooth;
  padding-bottom: 20px;
  padding-top: 20px;
  position: relative;

  grid-column: 1 / 7;
  @media (${device.desktop}) {
    grid-column: ${props => (props.fullWidth ? 1 : 2)} / 13;
  }
  ${props =>
    props.hybrid &&
    css`
      @media (${device.phone}) {
        flex-direction: column;
        overflow: visible;
        padding: 0;

        article {
          margin: 0 0 ${constants.margin10px} !important;
        }
      }
    `}:"";

  ${props =>
    props.forceSameWidthOnAllCards &&
    css`
      article {
        flex: 1;
      }
    `}
`

export const Item = styled.article`
  position: relative;

  :first-of-type {
    margin-left: 40px;
  }

  :last-of-type::after {
    content: "";
  }

  @media (${device.desktop}) {
    :first-of-type {
      margin-left: 0;
    }
  }
  + article {
    margin-left: 6px;

    @media (${device.tablet}) {
      margin-left: 12px;
    }
  }
`

const arrowButton = (
  leftMobile,
  left,
  rightMobile,
  right,
  baseTransform
) => css`
  position: absolute;
  top: 50%;
  left: ${leftMobile};
  right: ${rightMobile};
  transform: ${baseTransform};
  z-index: 10;
  opacity: 0;
  height: 0;
  width: 0;
  cursor: pointer;

  :hover {
    opacity: 0;
  }

  &.visible {
    width: 50px;
    height: 50px;
    opacity: 1;
    :hover {
      transform: ${baseTransform} scale(1.1);
    }
  }

  @media (${device.tablet}) {
    left: ${left};
    right: ${right};
  }
`

export const LeftArrowButton = styled(IconButtonWithShadow)`
  ${arrowButton(
    "15px",
    "45px",
    "auto",
    "auto",
    "translate(0, -50%) rotate(-180deg)"
  )};
`

export const RightArrowButton = styled(LeftArrowButton)`
  ${arrowButton("auto", "auto", "15px", "45px", "translate(0, -50%)")};
`
